export default __webpack_public_path__ + "static/media/withdrawal.784851ad.svg";